import { useTranslation } from '../../../../../utils/useTranslation';
import { SmartDrawer } from '../../../../feedback/SmartDrawer';
import { Typography } from '../../../../typography/Typography';
import { FeedManagementDatePopupContent } from '../FeedManagementDatePopupContent/FeedManagementDatePopupContent';
import { FeedManagementDateDrawerProps } from './types';

export const FeedManagementDateDrawer: React.FC<FeedManagementDateDrawerProps> = ({
    dateFrom,
    dateTo,
    onChange,
    onClose,
}) => {
    const t = useTranslation();

    return (
        <SmartDrawer
            onClose={onClose}
            titleContent={
                <Typography variant="title3" weight="bold">
                    {t('Выбрать даты')}
                </Typography>
            }
            mainContent={() => (
                <FeedManagementDatePopupContent
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    onChange={onChange}
                />
            )}
        />
    );
};
